import {getUserApiData} from "../../utils/UserUtils";
import {invokeApig} from "../../libs/awsLib";
import Paths from "../paths";
import {myID} from "../../libs/generateID";
import store from "../../store/store";
import {notify} from "reapop";
import i18n from "../../i18n";
import {
    createErrorNotification,
    createSuccessNotification,
} from "../../utils/ResponseUtils";

export function changeRFID(data, {FarmID, ClientID, LocalUserID} = {}) {
    const {_FarmID, _LocalUserID, _ClientID} = getUserApiData({
        FarmID,
        ClientID,
        LocalUserID,
    });
    return invokeApig({
        ...Paths.changeRFID({
            farmID: _FarmID,
            clientID: _ClientID,
            localUserID: _LocalUserID,
        }),
        body: data,
    });
}

export function changeRFIDNotificationSuccess(
    response,
    {uniqueId = myID()} = {}
) {
    if (createSuccessNotification(response, "logView.tableName.animals"))
        return;
    store.dispatch(
        notify({
            id: uniqueId,
            title: i18n.t("logView.tableName.animals"),
            message: i18n.t("apiNotifications.changeRFIDSuccess"),
            status: "success",
            dismissible: true,
            dismissAfter: 5000,
        })
    );
}

export function changeRFIDNotificationFailure(
    response,
    {uniqueId = myID()} = {}
) {
    if (
        createErrorNotification(response, "logView.tableName.animals", {
            uniqueId,
        })
    )
        return;
    store.dispatch(
        notify({
            id: uniqueId,
            title: i18n.t("logView.tableName.animals"),
            message: i18n.t("apiNotifications.changeRFIDFailure"),
            status: "error",
            dismissible: true,
            dismissAfter: 15000,
        })
    );
}
